/*
  Hercules product page restructure
  Nests the Tubs picker and Delivery Frequency inside the Subscribe
  option card. Tubs picker is duplicated visually into the One-time
  card via cloning.
  Runs after page load and existing rc-custom-widget, qty-break-picker,
  and rc-delivery-frequency components have initialized.
*/

(function () {
  'use strict';

  function init() {
    const widget = document.querySelector('.rc-widget-custom');
    if (!widget) return;

    const onetimeOption = widget.querySelector('.rc-widget-custom__option[data-type="onetime"]');
    const subscribeOption = widget.querySelector('.rc-widget-custom__option[data-type="subscription"]');
    const benefits = document.getElementById('rc-subscription-benefits');
    const frequency = document.getElementById('rc-delivery-frequency');
    const qtyPicker = document.querySelector('quantity-break-picker');

    if (!onetimeOption || !subscribeOption) return;

    /* ── Restructure: wrap each option + add nested content area ── */

    /* Build wrapper for the two cards so we can add per-card content panels */
    const optionsContainer = widget.querySelector('.rc-widget-custom__options');
    if (!optionsContainer) return;

    /* Convert horizontal options layout into stacked cards */
    optionsContainer.classList.add('rc-widget-custom__options--stacked');

    /* Create per-card content panels */
    const onetimePanel = document.createElement('div');
    onetimePanel.className = 'rc-widget-custom__panel rc-widget-custom__panel--onetime';
    onetimePanel.dataset.panelFor = 'onetime';

    const subscribePanel = document.createElement('div');
    subscribePanel.className = 'rc-widget-custom__panel rc-widget-custom__panel--subscribe';
    subscribePanel.dataset.panelFor = 'subscription';

    /* Move benefits into the subscribe panel */
    if (benefits) {
      benefits.classList.add('rc-widget-custom__benefits--nested');
      subscribePanel.appendChild(benefits);
    }

    /* Move the qty-break-picker into the subscribe panel as the primary,
       and clone it into the onetime panel as a visual mirror */
    let onetimeQtyClone = null;
    if (qtyPicker) {
      /* Clone first (before moving original) */
      onetimeQtyClone = qtyPicker.cloneNode(true);
      onetimeQtyClone.classList.add('qty-break-clone');
      /* Remove the custom element behavior on the clone — we'll sync manually */
      onetimeQtyClone.removeAttribute('data-quantity-break-picker');

      /* Give all clone radios the SAME name so they form a single radio group.
         Also clear all checked states first — we'll set the right one below. */
      const cloneRadios = onetimeQtyClone.querySelectorAll('input[type="radio"]');
      cloneRadios.forEach((input) => {
        input.name = 'qty-break-clone-group';
        input.checked = false;
        input.removeAttribute('checked');
        input.id = input.id + '-clone';
      });
      onetimeQtyClone.querySelectorAll('label').forEach((label) => {
        const newFor = label.getAttribute('for');
        if (newFor && !newFor.endsWith('-clone')) label.setAttribute('for', newFor + '-clone');
      });
      /* Also clear --selected class from all clone cards — only the matching
         original-checked one should be selected */
      onetimeQtyClone.querySelectorAll('.qty-break-card').forEach((card) => {
        card.classList.remove('qty-break-card--selected');
      });

      /* Now sync the clone to match the original's checked state */
      const originalCards = qtyPicker.querySelectorAll('.qty-break-card');
      originalCards.forEach((origCard, idx) => {
        const cloneCard = onetimeQtyClone.querySelectorAll('.qty-break-card')[idx];
        if (!cloneCard) return;
        if (origCard.classList.contains('qty-break-card--selected')) {
          cloneCard.classList.add('qty-break-card--selected');
          const cloneInput = cloneCard.querySelector('input[type="radio"]');
          if (cloneInput) cloneInput.checked = true;
        }
      });

      /* Move original into subscribe panel */
      subscribePanel.appendChild(qtyPicker);
      /* Put clone into onetime panel */
      onetimePanel.appendChild(onetimeQtyClone);
    }

    /* Move frequency selector into subscribe panel only */
    if (frequency) {
      frequency.classList.add('rc-widget-custom__frequency--nested');
      subscribePanel.appendChild(frequency);
    }

    /* Append panels AFTER their respective option cards inside the options container.
       We restructure: wrap each option + its panel in a card-group. */

    const onetimeGroup = document.createElement('div');
    onetimeGroup.className = 'rc-widget-custom__group rc-widget-custom__group--onetime';
    onetimeGroup.appendChild(onetimeOption);
    onetimeGroup.appendChild(onetimePanel);

    const subscribeGroup = document.createElement('div');
    subscribeGroup.className = 'rc-widget-custom__group rc-widget-custom__group--subscribe';
    subscribeGroup.appendChild(subscribeOption);
    subscribeGroup.appendChild(subscribePanel);

    /* Clear options container and rebuild with the new groups */
    optionsContainer.innerHTML = '';
    optionsContainer.appendChild(subscribeGroup);
    optionsContainer.appendChild(onetimeGroup);

    /* Sync the cloned tub selector clicks back to the original */
    if (onetimeQtyClone && qtyPicker) {
      onetimeQtyClone.querySelectorAll('.qty-break-card').forEach((cloneCard, idx) => {
        cloneCard.addEventListener('click', (e) => {
          /* Find the matching original card by index and click it */
          const originalCards = qtyPicker.querySelectorAll('.qty-break-card');
          if (originalCards[idx] && !originalCards[idx].classList.contains('qty-break-card--disabled')) {
            const originalInput = originalCards[idx].querySelector('input[type="radio"]');
            if (originalInput && !originalInput.disabled) {
              /* Update clone state immediately for visual feedback */
              onetimeQtyClone.querySelectorAll('input[type="radio"]').forEach((r) => {
                r.checked = false;
              });
              onetimeQtyClone.querySelectorAll('.qty-break-card').forEach((c) => {
                c.classList.remove('qty-break-card--selected');
              });
              const cloneInput = cloneCard.querySelector('input[type="radio"]');
              if (cloneInput) cloneInput.checked = true;
              cloneCard.classList.add('qty-break-card--selected');

              /* Trigger the original picker's logic */
              originalInput.checked = true;
              originalInput.dispatchEvent(new Event('change', { bubbles: true }));
              syncCloneState();
            }
          }
        });
      });
    }

    /* Watch the original picker for state changes and mirror to clone */
    function syncCloneState() {
      if (!onetimeQtyClone || !qtyPicker) return;
      const origCards = qtyPicker.querySelectorAll('.qty-break-card');
      const cloneCards = onetimeQtyClone.querySelectorAll('.qty-break-card');
      origCards.forEach((origCard, idx) => {
        const cloneCard = cloneCards[idx];
        if (!cloneCard) return;

        const origSelected = origCard.classList.contains('qty-break-card--selected');
        cloneCard.classList.toggle('qty-break-card--selected', origSelected);
        cloneCard.classList.toggle(
          'qty-break-card--disabled',
          origCard.classList.contains('qty-break-card--disabled')
        );

        /* Also sync the radio input checked state */
        const cloneInput = cloneCard.querySelector('input[type="radio"]');
        if (cloneInput) {
          cloneInput.checked = origSelected;
        }

        /* Mirror prices */
        const origPrice = origCard.querySelector('.qty-break-card__price');
        const clonePrice = cloneCard.querySelector('.qty-break-card__price');
        if (origPrice && clonePrice) {
          clonePrice.textContent = origPrice.textContent;
        }
      });
    }

    /* MutationObserver on the original picker to keep clone in sync */
    if (qtyPicker && onetimeQtyClone) {
      const obs = new MutationObserver(syncCloneState);
      obs.observe(qtyPicker, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
        characterData: true,
      });

      /* Also poll for text changes (price updates) since textContent changes
         don't always trigger MutationObserver on the parent */
      qtyPicker.querySelectorAll('.qty-break-card__price').forEach((priceEl) => {
        const priceObs = new MutationObserver(syncCloneState);
        priceObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
      });
    }

    /* ── Toggle visibility of panels based on selected option ── */

    function updatePanelVisibility() {
      const selectedType = widget.querySelector('.rc-widget-custom__option.is-selected')?.dataset.type;
      onetimePanel.classList.toggle('is-active', selectedType === 'onetime');
      subscribePanel.classList.toggle('is-active', selectedType === 'subscription');
      onetimeGroup.classList.toggle('is-selected', selectedType === 'onetime');
      subscribeGroup.classList.toggle('is-selected', selectedType === 'subscription');
    }

    /* Listen for clicks on the option cards (re-add since we restructured) */
    [onetimeOption, subscribeOption].forEach((opt) => {
      opt.addEventListener('click', () => {
        /* Existing rc-widget-custom click handler will toggle is-selected.
           We just re-run our visibility update on the next tick. */
        setTimeout(updatePanelVisibility, 0);
      });
    });

    /* Initial state */
    updatePanelVisibility();

    /* Mark widget as restructured so CSS can target specifically */
    widget.classList.add('rc-widget-custom--restructured');

    /* Show the price-wrap matching the active variant */
    const activeVariantId = widget.dataset.activeVariant;
    if (activeVariantId) {
      const activeWrap = widget.querySelector(
        `.rc-widget-custom__price-wrap[data-variant-id="${activeVariantId}"]`
      );
      if (activeWrap) activeWrap.classList.add('is-visible');
    } else {
      /* Fallback to first wrap */
      const firstWrap = widget.querySelector('.rc-widget-custom__price-wrap');
      if (firstWrap) firstWrap.classList.add('is-visible');
    }

    /* When variant changes (flavour swap), update which wrap is visible */
    document.addEventListener('variant:changed', (e) => {
      const newVariant = e.detail?.variant;
      if (!newVariant) return;
      widget.querySelectorAll('.rc-widget-custom__price-wrap').forEach((w) => {
        w.classList.toggle('is-visible', Number(w.dataset.variantId) === newVariant.id);
      });
    });
  }

  function tryInit() {
    /* Wait until the elements we need exist (other scripts may still be
       building them) — retry every 30ms up to 3 seconds */
    let attempts = 0;
    const maxAttempts = 100;

    function attempt() {
      attempts++;
      const widget = document.querySelector('.rc-widget-custom');
      const onetimeOpt = widget?.querySelector('.rc-widget-custom__option[data-type="onetime"]');
      const subscribeOpt = widget?.querySelector('.rc-widget-custom__option[data-type="subscription"]');

      if (widget && onetimeOpt && subscribeOpt) {
        init();
      } else if (attempts < maxAttempts) {
        setTimeout(attempt, 30);
      }
    }

    attempt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
